/* eslint-disable no-process-env */
/* global process */
const environment = process.env.NODE_ENV;
const debug = environment === 'development';

const config = {
    buildKey: typeof process.env.REACT_APP_BUILD_KEY === 'undefined' ? 'UNKNOWN' : process.env.REACT_APP_BUILD_KEY,
    debug,
    environment,
    sentryUrl: 'https://104c7d2b11a54f58943bcc9099b7cdf5@sentry.io/1858667',
    version: process.env.REACT_APP_VERSION,
};

export default config;
